import { v4 as uuidv4 } from 'uuid'
import { mapState } from 'vuex'

// todo: move there common things for all product items components
export default {
  name: 'ProductItemMixin',
  props: {
    product: {
      type: Object,
      required: true,
    },
    detailsEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    index: {
      type: Number,
      required: false,
      default: () => {
        return 0
      },
    },
  },
  computed: {
    ...mapState(['category']),
    productImgSrc() {
      return Array.isArray(this.product.img) && this.product.img.length
        ? `/img${this.product.img[0]}`
        : this.product.img
        ? `/img${this.product.img}`
        : '/img/uploads/error.png'
    },
    productImgSrcSet() {
      // extract missing w from filenames
      return this.product.srcset
        ? this.product.srcset
            .map(v => {
              let m = v.match(/(\d+)x\d+\.(png|jpg|jpeg|gif)$/i)
              if (m && m.length > 1) {
                return `/img${v} ${m[1]}w`
              } else {
                return `/img${v} 75w`
              }
            })
            .join(',')
        : ''
    },
    productImgSizes() {
      return this.productImgSrcSet ? '(max-width: 540px) 100vw, 540px' : ''
    },
    productImgWidth() {
      if (
        this.product.srcset &&
        this.product.srcset.find(v => v.match('540x540'))
      ) {
        return 540
      }
      return 410
    },
    productImgHeight() {
      if (
        this.product.srcset &&
        this.product.srcset.find(v => v.match('580x410'))
      ) {
        return 410
      }
      return 415
    },
    productName() {
      return this.product[`name_${this.$i18n.locale}`]
        ? this.product[`name_${this.$i18n.locale}`]
        : this.product.name
        ? this.product.name
        : ''
    },
    inCart() {
      return !!this.$store.state.cart.items.find(
        item => item.id === this.product._id
      )
    },
    categoryPath() {
      // return path to related category, by search in category tree by parentCategory and childCategory
      const cc = `${this.product.childCategory}`
      let refPath = `${this.product.parentCategory}/${cc.replace(',', '/')}`
      if (this.$cachedCategoryPaths[refPath]) {
        return this.$cachedCategoryPaths[refPath]
      }
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach(p => {
        if (!_c) return
        let c = _c.find(c => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c.slug
        }
      })
      this.$cachedCategoryPaths[refPath] = path
      return path
    },
  },
  methods: {
    onDetails() {
      if (this.$h.parseFalsy(this.$h.env('VUE_APP_PRODUCTS_BY_ID', 'true'))) {
        this.$store.dispatch('fetchProduct', this.product.id).then(() => {
          if (this.$store.state.product.id) {
            this.$store.commit('setProductInfoModal', this.$store.state.product)
          } else {
            this.$store.commit('setProductInfoModal', this.product)
          }
        })
      } else {
        const path = `${this.categoryPath}/${this.product.slug}`
        this.$store.dispatch('fetchProduct', path).then(() => {
          if (this.$store.state.product.id) {
            this.$store.commit('setProductInfoModal', this.$store.state.product)
          } else {
            this.$store.commit('setProductInfoModal', this.product)
          }
        })
      }
    },
    onClickProdcut(product, index) {
      //console.log('--->>here home')
      //console.log(product)
      let variant = ''
      let p = product
      if (p['filters']) {
        if (p['filters'][0]['color']) {
          variant = p['filters'][0]['color']
        }
        if (variant && p['filters'][0]['memory']) {
          variant = variant + ' ' + p['filters'][0]['memory']
        }
      }
      let listcat_full = this.categoryName(product)
      const item_list_id = uuidv4()
      this.$gtag.event('select_item', {
        items: [
          {
            item_name: p[`name_${this.$i18n.locale}`],
            item_id: p['id'],
            price: p['newPrice'] ? p['newPrice'] : p['price'],
            currency: 'UAH',
            item_brand: 'Apple',
            item_category: listcat_full,
            item_list_name: this.category[`name_${this.$i18n.locale}`],
            item_list_id,
            index: index || this.index,
            quantity: 1,
          },
        ],
      })
      return true
    },
    onAddToCart() {
      let item = {}
      let variant = ''
      let p = this.product
      if (p['filters']) {
        if (p['filters'][0]['color']) {
          variant = p['filters'][0]['color']
        }
        if (variant && p['filters'][0]['memory']) {
          variant = variant + ' ' + p['filters'][0]['memory']
        }
      }
      let listcat_full = this.categoryName(p)

      this.$h.gtmDataLayerPush({
        ecomm_pagetype: 'cart',
        ecomm_prodid: p['id'],
        ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
      })
      const item_list_id = uuidv4()
      this.$gtag.event('add_to_cart', {
        items: [
          {
            item_name: p[`name_${this.$i18n.locale}`],
            item_id: p['id'],
            price: p['newPrice'] ? p['newPrice'] : p['price'],
            currency: 'UAH',
            item_brand: 'Apple',
            item_category: listcat_full,
            item_list_name: 'Recommended products',
            item_list_id,
            index: 0,
            quantity: 1,
          },
        ],
      })
      Object.assign(item, this.product, { single: true })
      this.$store.dispatch('addToCart', item)
    },
    categoryName(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.$store.state.categories
      chain.forEach(p => {
        if (!_c) return
        let c = _c.find(c => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c[`name_${this.$i18n.locale}`]
        }
      })
      return path
    },
    onNotifyOnStock() {
      this.$store.commit('setProductModal', this.product)
      this.$store.commit('setNotifyStockModal', true)
    },
    onPreOrder() {
      this.$store.commit('setProductModal', this.product)
      this.$store.commit('setPreOrderModal', true)
    },
  },
}
